export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
  Upload: any;
};

export type Account = {
  admin?: Maybe<User>;
  id: Scalars['ID'];
  isShared?: Maybe<Scalars['Boolean']>;
  isSiteLicensed?: Maybe<Scalars['Boolean']>;
  isSmallBroker?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  type?: Maybe<Scalars['String']>;
};

export type AccountSetting = {
  buyside?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['ISO8601DateTime'];
  criteria?: Maybe<Scalars['JSON']>;
  customize?: Maybe<Scalars['JSON']>;
  dashboard?: Maybe<Scalars['JSON']>;
  features?: Maybe<Scalars['JSON']>;
  helpUrl?: Maybe<Scalars['String']>;
  homeTab?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  labels?: Maybe<Scalars['JSON']>;
  layouts?: Maybe<Scalars['JSON']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  offers?: Maybe<Scalars['JSON']>;
  pages?: Maybe<Scalars['JSON']>;
  restrictToMls?: Maybe<Array<Scalars['String']>>;
  supportEmail?: Maybe<Scalars['String']>;
  supportUrl?: Maybe<Scalars['String']>;
  tabs?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for AccountSetting. */
export type AccountSettingConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountSettingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AccountSetting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

/** An edge in a connection. */
export type AccountSettingEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AccountSetting>;
};

export enum AccountStatusEnum {
  Complete = 'complete',
  Invited = 'invited',
  NotSetup = 'notSetup',
  Onboarding = 'onboarding'
}

export type AdaptiveListingResult = {
  listings?: Maybe<Array<Listing>>;
};

/** Autogenerated return type of AddOrChangeAlternateMlsCredential. */
export type AddOrChangeAlternateMlsCredentialPayload = {
  alternateMlsCredential?: Maybe<AlternateMlsCredential>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type AddressSuggestionsResult = {
  addresses?: Maybe<Array<GeoAddress>>;
};

export type Agent = {
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  isBrokerAdmin: Scalars['Boolean'];
  lastLoggedIn?: Maybe<Scalars['ISO8601DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  recentReport?: Maybe<ReportInterface>;
  reportCount?: Maybe<Scalars['Int']>;
  status: AccountStatusEnum;
};

/** The connection type for Agent. */
export type AgentConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AgentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Agent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

/** An edge in a connection. */
export type AgentEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Agent>;
};

export enum AgentFilterFieldEnum {
  Name = 'name',
  Status = 'status'
}

export type AgentFilterInput = {
  field?: InputMaybe<AgentFilterFieldEnum>;
  value?: InputMaybe<Scalars['String']>;
};

export type AgentList = {
  agentId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum AgentSortEnum {
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type AgentUploadInput = {
  photoUrl?: InputMaybe<Scalars['String']>;
  user: UserInput;
};

export type AlternateMlsCredential = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type ApiCredential = {
  contextId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of Authenticate. */
export type AuthenticatePayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

export type BoostRedirectLink = {
  url?: Maybe<Scalars['String']>;
};

export type Broker = {
  activeAgentCount?: Maybe<Scalars['Int']>;
  admin?: Maybe<User>;
  agents: AgentConnection;
  classification?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inviteCount?: Maybe<Scalars['Int']>;
  key: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  mlsFeeds?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  officeAddress?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  seatsUsed?: Maybe<Scalars['Int']>;
  stats: BrokerStats;
  status: AccountStatusEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type BrokerAgentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<AgentFilterInput>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<AgentSortEnum>;
};

export enum BrokerFilterFieldEnum {
  Key = 'key',
  Name = 'name',
  Status = 'status'
}

export type BrokerFilterInput = {
  field: BrokerFilterFieldEnum;
  value: Scalars['String'];
};

export type BrokerMonthlyActiveUserStats = {
  singleMonthStats?: Maybe<Array<SingleMlsMonthlyStats>>;
};

export type BrokerStats = {
  monthlyActiveUsers?: Maybe<Array<BrokerMonthlyActiveUserStats>>;
};

/** Autogenerated return type of CancelBrokerAccount. */
export type CancelBrokerAccountPayload = {
  account?: Maybe<AccountSetting>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type Change = {
  changes?: Maybe<Array<ChangeDetail>>;
  timestamp?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ChangeDetail = {
  field?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type CmaReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  bathsMax?: Maybe<Scalars['Float']>;
  bathsMin?: Maybe<Scalars['Float']>;
  bedsMax?: Maybe<Scalars['Float']>;
  bedsMin?: Maybe<Scalars['Float']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  lotsizeMax?: Maybe<Scalars['Int']>;
  lotsizeMin?: Maybe<Scalars['Int']>;
  minListings?: Maybe<Scalars['Int']>;
  monthsBack?: Maybe<Scalars['Int']>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  priceListMax?: Maybe<Scalars['Int']>;
  priceListMin?: Maybe<Scalars['Int']>;
  proximitySearch?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  sqftMax?: Maybe<Scalars['Int']>;
  sqftMin?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type CmaWidgetInput = {
  address: Scalars['String'];
  apiKey: Scalars['String'];
  baths?: InputMaybe<Scalars['String']>;
  beds?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  delaySendInMinutes?: InputMaybe<Scalars['String']>;
  emailTo: Scalars['String'];
  garages?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  lotsize?: InputMaybe<Scalars['String']>;
  minListings?: InputMaybe<Scalars['String']>;
  monthsBack?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  propSubType?: InputMaybe<Scalars['String']>;
  propType?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
  yearBuilt?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CmaWidget. */
export type CmaWidgetPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  report?: Maybe<CmaReport>;
};

export type Color = {
  primary?: Maybe<Scalars['String']>;
  secondary: Scalars['String'];
};

/** Autogenerated return type of ConnectTransactionDesk. */
export type ConnectTransactionDeskPayload = {
  authorizedUrl?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of ConnectZipForm. */
export type ConnectZipFormPayload = {
  contextId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type ContactItem = {
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  prettyKey?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type ContactItemInput = {
  key: Scalars['String'];
  position: Scalars['Int'];
  value: Scalars['String'];
};

/** Autogenerated return type of CreateAccountSetting. */
export type CreateAccountSettingPayload = {
  accountSetting: AccountSetting;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateContactItem. */
export type CreateContactItemPayload = {
  contactItem?: Maybe<ContactItem>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateCustomPage. */
export type CreateCustomPagePayload = {
  customPage?: Maybe<CustomPage>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateCustomPdf. */
export type CreateCustomPdfPayload = {
  customPdf?: Maybe<CustomPdf>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of CreateFlyer. */
export type CreateFlyerPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  flyer?: Maybe<FlyerReport>;
};

/** Autogenerated return type of CreateListing. */
export type CreateListingPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listing?: Maybe<Listing>;
};

/** Autogenerated return type of CreateMagicLink. */
export type CreateMagicLinkPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of CreateProperty. */
export type CreatePropertyPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  property?: Maybe<PropertyReport>;
};

/** Autogenerated return type of CreateTour. */
export type CreateTourPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  tour?: Maybe<LiveTour>;
};

export type CustomPage = {
  canModify?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type CustomPageInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type CustomPdf = {
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type CustomPdfInput = {
  page: Scalars['Upload'];
};

/** Autogenerated return type of DestroyAccountSetting. */
export type DestroyAccountSettingPayload = {
  accountSetting: AccountSetting;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of DestroyAgent. */
export type DestroyAgentPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

/** Autogenerated return type of DestroyContactItem. */
export type DestroyContactItemPayload = {
  contactItem?: Maybe<ContactItem>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of DestroyCustomPage. */
export type DestroyCustomPagePayload = {
  customPage?: Maybe<CustomPage>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of DestroyCustomPdf. */
export type DestroyCustomPdfPayload = {
  customPdf?: Maybe<CustomPdf>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of DestroyListing. */
export type DestroyListingPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listing?: Maybe<Listing>;
};

/** Autogenerated return type of DestroyOrder. */
export type DestroyOrderPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DisconnectIntegration. */
export type DisconnectIntegrationPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  result?: Maybe<Scalars['Boolean']>;
};

export type DocumentReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type EmailReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type EmailReportInput = {
  msg: Scalars['String'];
  showLiveUrl: Scalars['Boolean'];
  showPdfUrl: Scalars['Boolean'];
  showSlideshowUrl: Scalars['Boolean'];
  subject: Scalars['String'];
  to: Scalars['String'];
};

/** Autogenerated return type of EmailReport. */
export type EmailReportPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  report?: Maybe<EmailReport>;
};

export type FlyerInput = {
  address?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  geoSource?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  layout?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['Float']>;
  mlsnum?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FlyerReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  headline?: Maybe<Select>;
  headlines?: Maybe<Array<Select>>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type GenerateBrokerAccountInput = {
  adminEmail: Scalars['String'];
  adminFirstName: Scalars['String'];
  adminLastName: Scalars['String'];
  brokerKey: Scalars['String'];
  brokerName: Scalars['String'];
  mlsFeeds?: InputMaybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of GenerateBrokerAccount. */
export type GenerateBrokerAccountPayload = {
  account?: Maybe<Broker>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type GeoAddress = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  mlsnum?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type HomebeatReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type Image = {
  height: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['String'];
};

/** Autogenerated return type of ImportAgents. */
export type ImportAgentsPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  importingErrors?: Maybe<Array<Scalars['String']>>;
  users?: Maybe<Array<User>>;
};

export type Integration = {
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export enum IntegrationTypeEnum {
  Ratedagent = 'ratedagent',
  Reach150 = 'reach150',
  Realsatisfied = 'realsatisfied',
  Testimonialtree = 'testimonialtree',
  Titlefy = 'titlefy',
  TransactionDesk = 'transaction_desk',
  Zillow = 'zillow',
  ZipForm = 'zip_form'
}

export type Invitation = {
  account: Broker;
  id: Scalars['ID'];
  userId: Scalars['ID'];
};

/** Autogenerated return type of InviteBroker. */
export type InviteBrokerPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  invitation?: Maybe<Invitation>;
};

export type LegacyRoute = {
  path?: Maybe<Scalars['String']>;
};

export type Listing = {
  acres?: Maybe<Scalars['Float']>;
  address?: Maybe<Scalars['String']>;
  agentList?: Maybe<AgentList>;
  area?: Maybe<Scalars['String']>;
  baths?: Maybe<Scalars['String']>;
  bathsFull?: Maybe<Scalars['String']>;
  bathsHalf?: Maybe<Scalars['String']>;
  bathsQuarter?: Maybe<Scalars['String']>;
  bathsThreeQuarter?: Maybe<Scalars['String']>;
  beds?: Maybe<Scalars['Int']>;
  /** as updates are pulled in, keep track of price and status changes */
  changes?: Maybe<Array<Change>>;
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  dateList?: Maybe<Scalars['ISO8601DateTime']>;
  dateOffmarket?: Maybe<Scalars['ISO8601DateTime']>;
  dateSold?: Maybe<Scalars['ISO8601DateTime']>;
  dom?: Maybe<Scalars['Int']>;
  features?: Maybe<Scalars['JSON']>;
  formattedBaths?: Maybe<Scalars['String']>;
  garages?: Maybe<Scalars['Int']>;
  geoLat?: Maybe<Scalars['Float']>;
  geoLon?: Maybe<Scalars['Float']>;
  hide?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  lotdim?: Maybe<Scalars['String']>;
  lotsize?: Maybe<Scalars['String']>;
  mappedStatus?: Maybe<Scalars['String']>;
  mlsnum?: Maybe<Scalars['String']>;
  officeList?: Maybe<OfficeList>;
  photos?: Maybe<Array<Scalars['String']>>;
  position?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  priceList?: Maybe<Scalars['Int']>;
  priceListOrig?: Maybe<Scalars['Int']>;
  pricePerSqft?: Maybe<Scalars['Float']>;
  priceRaw?: Maybe<Scalars['Int']>;
  priceSold?: Maybe<Scalars['Int']>;
  propType?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  remarksPrivate?: Maybe<Scalars['String']>;
  schoolElementary?: Maybe<Scalars['String']>;
  schoolHigh?: Maybe<Scalars['String']>;
  schoolMiddle?: Maybe<Scalars['String']>;
  schools?: Maybe<Array<School>>;
  source?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusAsColor?: Maybe<Scalars['String']>;
  statusAsLetter?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
  taxes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  yearBuilt?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type ListingInput = {
  address?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  baths?: InputMaybe<Scalars['Int']>;
  bathsFull?: InputMaybe<Scalars['Int']>;
  bathsHalf?: InputMaybe<Scalars['Int']>;
  beds?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  dateList?: InputMaybe<Scalars['ISO8601Date']>;
  dateSold?: InputMaybe<Scalars['ISO8601Date']>;
  garages?: InputMaybe<Scalars['Int']>;
  geoSource?: InputMaybe<Scalars['String']>;
  hide?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  lotdim?: InputMaybe<Scalars['String']>;
  lotsize?: InputMaybe<Scalars['Int']>;
  mlsnum?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<Array<Scalars['Upload']>>;
  price?: InputMaybe<Scalars['String']>;
  priceList?: InputMaybe<Scalars['Int']>;
  priceListOrig?: InputMaybe<Scalars['Int']>;
  priceSold?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  remarks?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<Scalars['String']>;
  subdivision?: InputMaybe<Scalars['String']>;
  taxes?: InputMaybe<Scalars['Float']>;
  yearBuilt?: InputMaybe<Scalars['Int']>;
};

export type ListingTranslation = {
  county: Scalars['String'];
};

export type LiveTour = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  agent?: Maybe<User>;
  appointments: Array<TourAppointment>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  tourDate?: Maybe<Scalars['ISO8601DateTime']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type LiveTourInput = {
  appointments?: InputMaybe<Array<TourAppointmentInput>>;
  date?: InputMaybe<Scalars['ISO8601DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Mls = {
  instructions?: Maybe<Scalars['String']>;
  isForge?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type MlsCredential = {
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isCanadian?: Maybe<Scalars['Boolean']>;
  mlsName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
};

export type MlsCredentialInput = {
  code: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
};

export type MlsOption = {
  mlsId?: Maybe<Scalars['String']>;
  mlsKey?: Maybe<Scalars['String']>;
  mlsName?: Maybe<Scalars['String']>;
  ouid?: Maybe<Scalars['String']>;
};

export type MlsTranslation = {
  label: Scalars['String'];
};

export type Mutation = {
  AddOrChangeAlternateMlsCredential?: Maybe<AddOrChangeAlternateMlsCredentialPayload>;
  authenticate?: Maybe<AuthenticatePayload>;
  cancelAccount?: Maybe<Scalars['Boolean']>;
  cancelBrokerAccount?: Maybe<CancelBrokerAccountPayload>;
  cmaWidget?: Maybe<CmaWidgetPayload>;
  connectTransactionDesk?: Maybe<ConnectTransactionDeskPayload>;
  connectZipForm?: Maybe<ConnectZipFormPayload>;
  createAccountSetting?: Maybe<CreateAccountSettingPayload>;
  createContactItem?: Maybe<CreateContactItemPayload>;
  createCustomPage?: Maybe<CreateCustomPagePayload>;
  createCustomPdf?: Maybe<CreateCustomPdfPayload>;
  createFlyer?: Maybe<CreateFlyerPayload>;
  createListing?: Maybe<CreateListingPayload>;
  createMagicLink?: Maybe<CreateMagicLinkPayload>;
  createProperty?: Maybe<CreatePropertyPayload>;
  createTour?: Maybe<CreateTourPayload>;
  destroyAccountSetting?: Maybe<DestroyAccountSettingPayload>;
  destroyAgent?: Maybe<DestroyAgentPayload>;
  destroyAlternateMlsCredential?: Maybe<Scalars['Boolean']>;
  destroyContactItem?: Maybe<DestroyContactItemPayload>;
  destroyCustomPage?: Maybe<DestroyCustomPagePayload>;
  destroyCustomPdf?: Maybe<DestroyCustomPdfPayload>;
  destroyFlyer?: Maybe<Scalars['Boolean']>;
  destroyListing?: Maybe<DestroyListingPayload>;
  destroyOrder?: Maybe<DestroyOrderPayload>;
  destroyProperty?: Maybe<Scalars['Boolean']>;
  disconnectIntegration?: Maybe<DisconnectIntegrationPayload>;
  emailReport?: Maybe<EmailReportPayload>;
  generateBrokerAccount?: Maybe<GenerateBrokerAccountPayload>;
  importAgents?: Maybe<ImportAgentsPayload>;
  inviteBroker?: Maybe<InviteBrokerPayload>;
  partnershipUserConnect?: Maybe<PartnershipUserConnectPayload>;
  partnershipUserSignup?: Maybe<PartnershipUserSignupPayload>;
  publishReport?: Maybe<PublishReportPayload>;
  requestResetPassword?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<ResetPasswordPayload>;
  sendAgentInvites?: Maybe<SendAgentInvitesPayload>;
  sortByListing?: Maybe<SortByListingPayload>;
  sortContactItems?: Maybe<SortContactItemsPayload>;
  sortListings?: Maybe<SortListingsPayload>;
  storeRedirectUrl?: Maybe<StoreRedirectUrlPayload>;
  toggleListingVisibility?: Maybe<ToggleListingVisibilityPayload>;
  updateAccountSetting?: Maybe<UpdateAccountSettingPayload>;
  updateBrokerAccount?: Maybe<UpdateBrokerAccountPayload>;
  updateCustomPage?: Maybe<UpdateCustomPagePayload>;
  updateFlyer?: Maybe<UpdateFlyerPayload>;
  updateIntegrationCredential?: Maybe<UpdateIntegrationCredentialPayload>;
  updateListing?: Maybe<UpdateListingPayload>;
  updateMlsCredential?: Maybe<UpdateMlsCredentialPayload>;
  updateProperty?: Maybe<UpdatePropertyPayload>;
  updatePublicListing?: Maybe<UpdatePublicListingPayload>;
  updateReportListingsVisibility?: Maybe<UpdateReportListingsVisibilityPayload>;
  updateSubscriptionPlan?: Maybe<UpdateSubscriptionPlanPayload>;
  updateTour?: Maybe<UpdateTourPayload>;
  updateUserConfig?: Maybe<UpdateUserConfigPayload>;
  updateUserPassword?: Maybe<UpdateUserPasswordPayload>;
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  uploadCustomImage?: Maybe<UploadCustomImagePayload>;
};


export type MutationAddOrChangeAlternateMlsCredentialArgs = {
  alternateMlsCredentialId?: InputMaybe<Scalars['ID']>;
  input: MlsCredentialInput;
};


export type MutationAuthenticateArgs = {
  login: Scalars['String'];
  partnershipLogin?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
};


export type MutationCancelBrokerAccountArgs = {
  id: Scalars['ID'];
};


export type MutationCmaWidgetArgs = {
  input: CmaWidgetInput;
};


export type MutationConnectTransactionDeskArgs = {
  reportId?: InputMaybe<Scalars['ID']>;
  returnPath: Scalars['String'];
};


export type MutationConnectZipFormArgs = {
  password?: InputMaybe<Scalars['String']>;
  refresh?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAccountSettingArgs = {
  buyside?: InputMaybe<Scalars['JSON']>;
  criteria?: InputMaybe<Scalars['JSON']>;
  customize?: InputMaybe<Scalars['JSON']>;
  dashboard?: InputMaybe<Scalars['JSON']>;
  features?: InputMaybe<Scalars['JSON']>;
  helpUrl?: InputMaybe<Scalars['String']>;
  homeTab?: InputMaybe<Scalars['JSON']>;
  labels?: InputMaybe<Scalars['JSON']>;
  layouts?: InputMaybe<Scalars['JSON']>;
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  offers?: InputMaybe<Scalars['JSON']>;
  pages?: InputMaybe<Scalars['JSON']>;
  restrictToMls?: InputMaybe<Array<Scalars['String']>>;
  supportEmail?: InputMaybe<Scalars['String']>;
  supportUrl?: InputMaybe<Scalars['String']>;
  tabs?: InputMaybe<Scalars['JSON']>;
};


export type MutationCreateContactItemArgs = {
  input: ContactItemInput;
};


export type MutationCreateCustomPageArgs = {
  input: CustomPageInput;
};


export type MutationCreateCustomPdfArgs = {
  input: CustomPdfInput;
};


export type MutationCreateFlyerArgs = {
  input: FlyerInput;
};


export type MutationCreateListingArgs = {
  input: ListingInput;
  reportId: Scalars['ID'];
};


export type MutationCreateMagicLinkArgs = {
  email: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationCreatePropertyArgs = {
  input: PropertyInput;
};


export type MutationCreateTourArgs = {
  input: LiveTourInput;
};


export type MutationDestroyAccountSettingArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyAgentArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyAlternateMlsCredentialArgs = {
  alternateMlsCredentialId: Scalars['ID'];
};


export type MutationDestroyContactItemArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyCustomPageArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyCustomPdfArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyFlyerArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyListingArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyOrderArgs = {
  id: Scalars['ID'];
};


export type MutationDestroyPropertyArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectIntegrationArgs = {
  key: IntegrationTypeEnum;
};


export type MutationEmailReportArgs = {
  id: Scalars['ID'];
  input: EmailReportInput;
};


export type MutationGenerateBrokerAccountArgs = {
  brokerAccount: GenerateBrokerAccountInput;
};


export type MutationImportAgentsArgs = {
  accountId: Scalars['ID'];
  agents: Array<AgentUploadInput>;
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInviteBrokerArgs = {
  accountId: Scalars['ID'];
};


export type MutationPartnershipUserConnectArgs = {
  ouid: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPartnershipUserSignupArgs = {
  input: UserInput;
  ouid: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPublishReportArgs = {
  id: Scalars['ID'];
  template?: InputMaybe<Scalars['String']>;
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationSendAgentInvitesArgs = {
  accountId: Scalars['ID'];
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSortByListingArgs = {
  direction: SortDirectionEnum;
  field: Scalars['String'];
  reportId: Scalars['ID'];
};


export type MutationSortContactItemsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationSortListingsArgs = {
  ids: Array<Scalars['ID']>;
  reportId: Scalars['ID'];
};


export type MutationStoreRedirectUrlArgs = {
  scope: Scalars['String'];
  url: Scalars['String'];
};


export type MutationToggleListingVisibilityArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAccountSettingArgs = {
  buyside?: InputMaybe<Scalars['JSON']>;
  criteria?: InputMaybe<Scalars['JSON']>;
  customize?: InputMaybe<Scalars['JSON']>;
  dashboard?: InputMaybe<Scalars['JSON']>;
  features?: InputMaybe<Scalars['JSON']>;
  helpUrl?: InputMaybe<Scalars['String']>;
  homeTab?: InputMaybe<Scalars['JSON']>;
  id: Scalars['ID'];
  labels?: InputMaybe<Scalars['JSON']>;
  layouts?: InputMaybe<Scalars['JSON']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Scalars['JSON']>;
  pages?: InputMaybe<Scalars['JSON']>;
  restrictToMls?: InputMaybe<Array<Scalars['String']>>;
  supportEmail?: InputMaybe<Scalars['String']>;
  supportUrl?: InputMaybe<Scalars['String']>;
  tabs?: InputMaybe<Scalars['JSON']>;
};


export type MutationUpdateBrokerAccountArgs = {
  input: UpdateBrokerAccountInput;
};


export type MutationUpdateCustomPageArgs = {
  id: Scalars['ID'];
  input: CustomPageInput;
};


export type MutationUpdateFlyerArgs = {
  id: Scalars['ID'];
  input: FlyerInput;
  updateListings?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateIntegrationCredentialArgs = {
  key: IntegrationTypeEnum;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateListingArgs = {
  id: Scalars['ID'];
  input: ListingInput;
};


export type MutationUpdateMlsCredentialArgs = {
  input: MlsCredentialInput;
};


export type MutationUpdatePropertyArgs = {
  id: Scalars['ID'];
  input: PropertyInput;
};


export type MutationUpdatePublicListingArgs = {
  id: Scalars['ID'];
  input: PublicListingInput;
};


export type MutationUpdateReportListingsVisibilityArgs = {
  reportId: Scalars['ID'];
  visible: Scalars['Boolean'];
};


export type MutationUpdateSubscriptionPlanArgs = {
  discountCode?: InputMaybe<Scalars['String']>;
  paymentNonce?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateTourArgs = {
  id: Scalars['ID'];
  input: LiveTourInput;
};


export type MutationUpdateUserConfigArgs = {
  input: UserConfigInput;
};


export type MutationUpdateUserPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUpdateUserProfileArgs = {
  input: UserProfileInput;
};


export type MutationUploadCustomImageArgs = {
  input: UploadCustomImageInput;
};

export type OfficeList = {
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Order = UserReceiptInterface & {
  amount?: Maybe<Scalars['Float']>;
  billingUrl?: Maybe<Scalars['String']>;
  chargeDate?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  isPaid?: Maybe<Scalars['Boolean']>;
  isRecurring?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  product: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PageTemplate = {
  id?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  pageCount?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type Parcel = {
  acres?: Maybe<Scalars['Float']>;
  address?: Maybe<Scalars['String']>;
  baths?: Maybe<Scalars['Float']>;
  beds?: Maybe<Scalars['Int']>;
  cooling?: Maybe<Scalars['String']>;
  garages?: Maybe<Scalars['Int']>;
  heating?: Maybe<Scalars['String']>;
  lotsize?: Maybe<Scalars['Int']>;
  parsedAddress?: Maybe<ParcelParsedAddress>;
  sqft?: Maybe<Scalars['Float']>;
  stories?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Float']>;
  yearBuilt?: Maybe<Scalars['Int']>;
};

export type ParcelParsedAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  redundantStreetType?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
};

export type PartnershipUser = {
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  mls?: Maybe<Mls>;
  mlsId?: Maybe<Scalars['String']>;
  mlsOptions?: Maybe<Array<MlsOption>>;
  ouid?: Maybe<Scalars['String']>;
  partnershipId?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of PartnershipUserConnect. */
export type PartnershipUserConnectPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  redirectUrl?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of PartnershipUserSignup. */
export type PartnershipUserSignupPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  redirectUrl?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type PropertyInput = {
  address: Scalars['String'];
  callbackUrl?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type PropertyReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type PublicListingInput = {
  comment?: InputMaybe<Scalars['String']>;
  /** 0 for not liked, 1 for liked */
  rating?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of PublishReport. */
export type PublishReportPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  report?: Maybe<ReportInterface>;
};

export type Query = {
  accountSetting: AccountSetting;
  accountSettings: AccountSettingConnection;
  addressSuggestions?: Maybe<AddressSuggestionsResult>;
  allStates?: Maybe<Array<Scalars['String']>>;
  boostRedirectLink: BoostRedirectLink;
  broker?: Maybe<Broker>;
  brokers: Array<Broker>;
  btGatewayToken?: Maybe<Scalars['String']>;
  caStates?: Maybe<Array<Scalars['String']>>;
  currentUser?: Maybe<User>;
  listingsByAddressOrMlsNums?: Maybe<AdaptiveListingResult>;
  mls: Mls;
  mlses: Array<Mls>;
  parcel?: Maybe<Parcel>;
  partnershipUser?: Maybe<PartnershipUser>;
  potentialUsers?: Maybe<Array<User>>;
  report?: Maybe<ReportInterface>;
  reports?: Maybe<ReportInterfaceConnection>;
  resoOrg?: Maybe<Mls>;
  resoOrgs?: Maybe<Array<ResoOrg>>;
  tour?: Maybe<LiveTour>;
  translations: Translation;
  usStates?: Maybe<Array<Scalars['String']>>;
  /** User query based on id, email, or guid */
  user?: Maybe<User>;
  userReportTemplates?: Maybe<UserReportTemplates>;
};


export type QueryAccountSettingArgs = {
  id: Scalars['ID'];
};


export type QueryAccountSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAddressSuggestionsArgs = {
  address: Scalars['String'];
};


export type QueryBrokerArgs = {
  id: Scalars['ID'];
};


export type QueryBrokersArgs = {
  filters?: InputMaybe<Array<BrokerFilterInput>>;
};


export type QueryListingsByAddressOrMlsNumsArgs = {
  query: Scalars['String'];
};


export type QueryMlsArgs = {
  key: Scalars['String'];
};


export type QueryMlsesArgs = {
  restrict?: InputMaybe<Scalars['Boolean']>;
};


export type QueryParcelArgs = {
  address: Scalars['String'];
};


export type QueryPartnershipUserArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryPotentialUsersArgs = {
  token: Scalars['String'];
};


export type QueryReportArgs = {
  id: Scalars['ID'];
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  reportTypes?: InputMaybe<Array<ReportTypeEnum>>;
  sort?: InputMaybe<SortInput>;
};


export type QueryResoOrgArgs = {
  ouid: Scalars['String'];
};


export type QueryResoOrgsArgs = {
  ouids: Array<Scalars['String']>;
};


export type QueryTourArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  guid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUserReportTemplatesArgs = {
  reportId: Scalars['ID'];
};

export type ReportInterface = {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

/** The connection type for ReportInterface. */
export type ReportInterfaceConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportInterfaceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReportInterface>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  total: Scalars['Int'];
};

/** An edge in a connection. */
export type ReportInterfaceEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReportInterface>;
};

export enum ReportThemeTypeEnum {
  Classic = 'classic',
  Modern = 'modern'
}

export enum ReportTypeEnum {
  /** CMA Report */
  Cma = 'Cma',
  /** Document */
  Document = 'Document',
  /** Flyer */
  Flyer = 'Flyer',
  /** Property Report */
  Property = 'Property',
  /** Buyer Tour */
  Tour = 'Tour'
}

/** Autogenerated return type of ResetPassword. */
export type ResetPasswordPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

export type ResoOrg = {
  address?: Maybe<Scalars['String']>;
  assoc2mls?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  mlsKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ouid?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type School = {
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  districtId?: Maybe<Scalars['Int']>;
  districtName?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  fipscounty?: Maybe<Scalars['Int']>;
  gradeRange?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  level?: Maybe<Scalars['String']>;
  levelCodes?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  ncesId?: Maybe<Scalars['String']>;
  overviewUrl?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  ratingDescription?: Maybe<Scalars['String']>;
  schoolSummary?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateId?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  universalId?: Maybe<Scalars['String']>;
  webSite?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
};

export type Select = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SelectFont = {
  key: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type SelectLayout = {
  key: Scalars['String'];
  preview?: Maybe<Scalars['String']>;
  type: ReportThemeTypeEnum;
  value: Scalars['String'];
};

export type SelectTheme = {
  color: Color;
  key: Scalars['String'];
  preview?: Maybe<Array<Scalars['String']>>;
  type: ThemeTypeEnum;
  value: Scalars['String'];
};

/** Autogenerated return type of SendAgentInvites. */
export type SendAgentInvitesPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  invitations?: Maybe<Array<Invitation>>;
};

export type SingleMlsMonthlyStats = {
  buyerActiveUsers: Scalars['Int'];
  cmaActiveUsers: Scalars['Int'];
  flyerActiveUsers: Scalars['Int'];
  homebeatActiveUsers: Scalars['Int'];
  mls: Mls;
  month: Scalars['String'];
  propertyActiveUsers: Scalars['Int'];
  totalActiveUsers: Scalars['Int'];
  totalUsers: Scalars['Int'];
};

/** Autogenerated return type of SortByListing. */
export type SortByListingPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listings?: Maybe<Array<Listing>>;
};

/** Autogenerated return type of SortContactItems. */
export type SortContactItemsPayload = {
  contactItems?: Maybe<Array<ContactItem>>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortFieldEnum {
  CreatedAt = 'created_at',
  UpdatedAt = 'updated_at'
}

export type SortInput = {
  dir?: InputMaybe<SortDirectionEnum>;
  field?: InputMaybe<SortFieldEnum>;
};

/** Autogenerated return type of SortListings. */
export type SortListingsPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listings?: Maybe<Array<Listing>>;
};

/** Autogenerated return type of StoreRedirectUrl. */
export type StoreRedirectUrlPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type SubjectProperty = {
  acres?: Maybe<Scalars['Float']>;
  address?: Maybe<Scalars['String']>;
  area?: Maybe<Scalars['String']>;
  baths?: Maybe<Scalars['Float']>;
  beds?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  garages?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  landMeasurement?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  lotSize?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  propSubType?: Maybe<Scalars['String']>;
  propType?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['Int']>;
  style?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
  taxes?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  yearBuilt?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  affiliate?: Maybe<SubscriptionAffiliate>;
  amount?: Maybe<Scalars['Float']>;
  cardExpiration?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  discount?: Maybe<SubscriptionDiscount>;
  hasSubscriptionPayments?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isFree?: Maybe<Scalars['Boolean']>;
  isPurchasedFromOutsideStore?: Maybe<Scalars['Boolean']>;
  nextRenewalAt?: Maybe<Scalars['ISO8601DateTime']>;
  state?: Maybe<Scalars['String']>;
  subscriptionPlan?: Maybe<SubscriptionPlan>;
};

export type SubscriptionAffiliate = {
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type SubscriptionDiscount = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  id: Scalars['ID'];
};

export type SubscriptionPayment = UserReceiptInterface & {
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  product: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type SubscriptionPlan = {
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum SubscriptionPlatformEnum {
  CloudAgentSuite = 'CloudAgentSuite',
  Cma = 'Cma',
  Ecommerce = 'Ecommerce'
}

export enum ThemeTypeEnum {
  Affiliates = 'Affiliates',
  Custom = 'Custom',
  Franchise = 'Franchise',
  Modern = 'Modern'
}

/** Autogenerated return type of ToggleListingVisibility. */
export type ToggleListingVisibilityPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listing?: Maybe<Listing>;
};

export type TourAppointment = {
  comment?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  like?: Maybe<Scalars['Boolean']>;
  listing: Listing;
  note?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['ISO8601DateTime']>;
};

export type TourAppointmentInput = {
  comment?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  like?: InputMaybe<Scalars['Boolean']>;
  mlsNumber?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type TourReport = ReportInterface & {
  address?: Maybe<Scalars['String']>;
  cities?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description: Scalars['String'];
  font: Select;
  fonts?: Maybe<Array<SelectFont>>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModern?: Maybe<Scalars['Boolean']>;
  lastViewedAt?: Maybe<Scalars['ISO8601DateTime']>;
  layout: Select;
  layouts: Array<SelectLayout>;
  listingCount?: Maybe<Scalars['Int']>;
  listings?: Maybe<Array<Listing>>;
  notes?: Maybe<Scalars['String']>;
  pageTemplate?: Maybe<Scalars['String']>;
  pdfPermalink?: Maybe<Scalars['String']>;
  pdfUrl?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']>;
  reportAddressParts?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subjectProperty?: Maybe<SubjectProperty>;
  theme: Select;
  themes: Array<SelectTheme>;
  thumbnailUrlWithTimestamp?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  viewCount?: Maybe<Scalars['Int']>;
};

export type Translation = {
  listing: ListingTranslation;
  mls: MlsTranslation;
};

/** Autogenerated return type of UpdateAccountSetting. */
export type UpdateAccountSettingPayload = {
  accountSetting: AccountSetting;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateBrokerAccountInput = {
  brokerAdminIds?: InputMaybe<Array<Scalars['ID']>>;
  brokerName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['Upload']>;
  logoCropDimensions?: InputMaybe<Scalars['String']>;
  mlsFeeds?: InputMaybe<Array<Scalars['String']>>;
  officeAddress?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateBrokerAccount. */
export type UpdateBrokerAccountPayload = {
  account?: Maybe<Broker>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpdateCustomPage. */
export type UpdateCustomPagePayload = {
  customPage?: Maybe<CustomPage>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpdateFlyer. */
export type UpdateFlyerPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  flyer?: Maybe<FlyerReport>;
};

/** Autogenerated return type of UpdateIntegrationCredential. */
export type UpdateIntegrationCredentialPayload = {
  apiCredential?: Maybe<ApiCredential>;
  errors?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of UpdateListing. */
export type UpdateListingPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listing?: Maybe<Listing>;
};

/** Autogenerated return type of UpdateMlsCredential. */
export type UpdateMlsCredentialPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  mlsCredential?: Maybe<MlsCredential>;
};

/** Autogenerated return type of UpdateProperty. */
export type UpdatePropertyPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  property?: Maybe<PropertyReport>;
};

/** Autogenerated return type of UpdatePublicListing. */
export type UpdatePublicListingPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listing?: Maybe<Listing>;
};

/** Autogenerated return type of UpdateReportListingsVisibility. */
export type UpdateReportListingsVisibilityPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  listings?: Maybe<Array<Listing>>;
};

/** Autogenerated return type of UpdateSubscriptionPlan. */
export type UpdateSubscriptionPlanPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  result?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of UpdateTour. */
export type UpdateTourPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  tour?: Maybe<LiveTour>;
};

/** Autogenerated return type of UpdateUserConfig. */
export type UpdateUserConfigPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUserPassword. */
export type UpdateUserPasswordPayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUserProfile. */
export type UpdateUserProfilePayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

export type UploadCustomImageInput = {
  image?: InputMaybe<Scalars['Upload']>;
};

/** Autogenerated return type of UploadCustomImage. */
export type UploadCustomImagePayload = {
  errors?: Maybe<Array<Scalars['String']>>;
  image?: Maybe<Image>;
};

export type User = {
  account?: Maybe<Account>;
  alternateMlsCredentials?: Maybe<Array<AlternateMlsCredential>>;
  autoSendWebleadEmail?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  belongsToBroker?: Maybe<Scalars['Boolean']>;
  casJwt?: Maybe<Scalars['String']>;
  casUserId?: Maybe<Scalars['ID']>;
  city?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  companyLogoName?: Maybe<Scalars['String']>;
  companyLogoUrl?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  connectedToLwa?: Maybe<Scalars['Boolean']>;
  contactItems?: Maybe<Array<ContactItem>>;
  contactMethods?: Maybe<Array<ContactItem>>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customPages?: Maybe<Array<CustomPage>>;
  customPdfs?: Maybe<Array<CustomPdf>>;
  deleted?: Maybe<Scalars['Boolean']>;
  eligiblePlans?: Maybe<Array<SubscriptionPlan>>;
  email: Scalars['String'];
  features?: Maybe<UserFeatures>;
  guid?: Maybe<Scalars['String']>;
  hasCardOnFile?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  integrations?: Maybe<Array<Integration>>;
  isAccountAdmin?: Maybe<Scalars['Boolean']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isAuthSso?: Maybe<Scalars['Boolean']>;
  isCasUser?: Maybe<Scalars['Boolean']>;
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  legacyRoutes?: Maybe<Array<LegacyRoute>>;
  licenseLabel?: Maybe<Scalars['String']>;
  licenseNumber?: Maybe<Scalars['String']>;
  liveToursEnabled?: Maybe<Scalars['Boolean']>;
  lwaId?: Maybe<Scalars['String']>;
  lwaJwt?: Maybe<Scalars['String']>;
  mlsCredential?: Maybe<MlsCredential>;
  mobilePhone?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officeAddress?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  orders?: Maybe<Array<Order>>;
  passwordSetAt?: Maybe<Scalars['ISO8601DateTime']>;
  platformUid?: Maybe<Scalars['String']>;
  receipts?: Maybe<Array<UserReceiptInterface>>;
  role: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  stats?: Maybe<UserStats>;
  status: UserStatusEnum;
  subscriptionPayments?: Maybe<Array<SubscriptionPayment>>;
  subscriptionPlatform?: Maybe<SubscriptionPlatformEnum>;
  transactionDeskToken?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userHash?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  zipFormToken?: Maybe<Scalars['String']>;
};

export type UserConfigInput = {
  autoSendWebleadEmail?: InputMaybe<Scalars['Boolean']>;
  liveToursEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserFeatures = {
  canEditMls?: Maybe<Scalars['Boolean']>;
  canEditRemarks?: Maybe<Scalars['Boolean']>;
  hasAddressAutocomplete?: Maybe<Scalars['Boolean']>;
  hasApiButton?: Maybe<Scalars['Boolean']>;
  hasBrokerAccess?: Maybe<Scalars['Boolean']>;
  hasDocuments?: Maybe<Scalars['Boolean']>;
  hasFlyers?: Maybe<Scalars['Boolean']>;
  hasHomebeat?: Maybe<Scalars['Boolean']>;
  hasIbuyerConnect?: Maybe<Scalars['Boolean']>;
  hasLive?: Maybe<Scalars['Boolean']>;
  hasLiveTours?: Maybe<Scalars['Boolean']>;
  hasPresent?: Maybe<Scalars['Boolean']>;
  hasPresentation?: Maybe<Scalars['Boolean']>;
  hasRdcToolkit?: Maybe<Scalars['Boolean']>;
  hasTransactions?: Maybe<Scalars['Boolean']>;
  intercomChat?: Maybe<Scalars['Boolean']>;
  luxePowerPack?: Maybe<Scalars['Boolean']>;
  luxePowerPackUpgrade?: Maybe<Scalars['Boolean']>;
  offerHomebeat?: Maybe<Scalars['Boolean']>;
  offerRdcToolkit?: Maybe<Scalars['Boolean']>;
  packMarketing2013?: Maybe<Scalars['Boolean']>;
  tomFerryLpkt?: Maybe<Scalars['Boolean']>;
};

export type UserInput = {
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  mlsId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UserProfileInput = {
  city?: InputMaybe<Scalars['String']>;
  companyname?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['Upload']>;
  logoCropDimensions?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officeAddress?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['Upload']>;
  photoCropDimensions?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type UserReceiptInterface = {
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['ISO8601DateTime'];
  product: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UserReportTemplates = {
  pageTemplates?: Maybe<Array<PageTemplate>>;
};

export type UserStats = {
  buyerCount?: Maybe<Scalars['Int']>;
  cmaCount?: Maybe<Scalars['Int']>;
  flyerCount?: Maybe<Scalars['Int']>;
  propertyCount?: Maybe<Scalars['Int']>;
};

export enum UserStatusEnum {
  Complete = 'complete',
  Invited = 'invited',
  NotSetup = 'notSetup',
  Onboarding = 'onboarding'
}

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser?: { id: string, name: string, email: string, avatar?: string | null, guid?: string | null, companyName?: string | null, companyLogoUrl?: string | null, companyLogoName?: string | null, city?: string | null, state?: string | null, status: UserStatusEnum, casUserId?: string | null, isCasUser?: boolean | null, isAdmin?: boolean | null, passwordSetAt?: any | null, liveToursEnabled?: boolean | null, isAuthSso?: boolean | null, role: number, zipFormToken?: string | null, transactionDeskToken?: string | null, subscriptionPlatform?: SubscriptionPlatformEnum | null, platformUid?: string | null, autoSendWebleadEmail?: boolean | null, mobilePhone?: string | null, officeAddress?: string | null, officePhone?: string | null, isAccountAdmin?: boolean | null, lwaId?: string | null, lwaJwt?: string | null, casJwt?: string | null, mlsCredential?: { code?: string | null, name?: string | null, password?: string | null } | null, features?: { canEditMls?: boolean | null, canEditRemarks?: boolean | null, hasAddressAutocomplete?: boolean | null, hasApiButton?: boolean | null, hasDocuments?: boolean | null, hasFlyers?: boolean | null, hasHomebeat?: boolean | null, hasIbuyerConnect?: boolean | null, hasLive?: boolean | null, hasLiveTours?: boolean | null, hasPresent?: boolean | null, hasTransactions?: boolean | null, offerHomebeat?: boolean | null, hasBrokerAccess?: boolean | null, offerRdcToolkit?: boolean | null, hasRdcToolkit?: boolean | null, hasPresentation?: boolean | null } | null, account?: { name?: string | null, id: string, key?: string | null, isSmallBroker?: boolean | null, admin?: { email: string, companyLogoUrl?: string | null } | null } | null } | null };

export type StoreRedirectUrlMutationVariables = Exact<{
  scope: Scalars['String'];
  url: Scalars['String'];
}>;


export type StoreRedirectUrlMutation = { storeRedirectUrl?: { success: boolean } | null };

export type UpdateUserConfigMutationVariables = Exact<{
  input: UserConfigInput;
}>;


export type UpdateUserConfigMutation = { updateUserConfig?: { errors?: Array<string> | null, user?: { id: string } | null } | null };

export type BraintreeTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type BraintreeTokenQuery = { btGatewayToken?: string | null };

export type UploadCustomImageMutationVariables = Exact<{
  input: UploadCustomImageInput;
}>;


export type UploadCustomImageMutation = { uploadCustomImage?: { errors?: Array<string> | null, image?: { url: string, width: string, height: string } | null } | null };

export type LegacyRoutesQueryVariables = Exact<{ [key: string]: never; }>;


export type LegacyRoutesQuery = { currentUser?: { features?: { hasLiveTours?: boolean | null } | null, legacyRoutes?: Array<{ path?: string | null }> | null } | null };

export type AddressSearchQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type AddressSearchQuery = { addressSuggestions?: { addresses?: Array<{ address?: string | null, city?: string | null, lat?: number | null, lon?: number | null, mlsnum?: string | null, state?: string | null, zipcode?: string | null }> | null } | null };

export type TaxDataQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type TaxDataQuery = { parcel?: { acres?: number | null, address?: string | null, baths?: number | null, beds?: number | null, cooling?: string | null, garages?: number | null, heating?: string | null, sqft?: number | null, stories?: number | null, taxes?: number | null, yearBuilt?: number | null, lostSize?: number | null, parsedAddress?: { city?: string | null, number?: string | null, postalCode?: string | null, redundantStreetType?: boolean | null, state?: string | null, street?: string | null, streetType?: string | null } | null } | null };

export type AccountSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountSettingsQuery = { accountSettings: { edges?: Array<{ node?: { id: string, name: string } | null } | null> | null } };

export type AccountSettingQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountSettingQuery = { accountSetting: { id: string, buyside?: any | null, criteria?: any | null, customize?: any | null, dashboard?: any | null, features?: any | null, labels?: any | null, layouts?: any | null, logo?: string | null, name: string, offers?: any | null, pages?: any | null, tabs?: any | null, help_url?: string | null, home_tab?: any | null, restrict_to_mls?: Array<string> | null, support_email?: string | null, support_url?: string | null } };

export type CreateAccountSettingMutationVariables = Exact<{
  home_tab?: InputMaybe<Scalars['JSON']>;
  buyside?: InputMaybe<Scalars['JSON']>;
  criteria?: InputMaybe<Scalars['JSON']>;
  customize?: InputMaybe<Scalars['JSON']>;
  dashboard?: InputMaybe<Scalars['JSON']>;
  features?: InputMaybe<Scalars['JSON']>;
  help_url?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['JSON']>;
  layouts?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Scalars['JSON']>;
  pages?: InputMaybe<Scalars['JSON']>;
  restrict_to_mls?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  support_email?: InputMaybe<Scalars['String']>;
  support_url?: InputMaybe<Scalars['String']>;
  tabs?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateAccountSettingMutation = { createAccountSetting?: { accountSetting: { id: string } } | null };

export type UpdateAccountSettingMutationVariables = Exact<{
  id: Scalars['ID'];
  home_tab?: InputMaybe<Scalars['JSON']>;
  buyside?: InputMaybe<Scalars['JSON']>;
  criteria?: InputMaybe<Scalars['JSON']>;
  customize?: InputMaybe<Scalars['JSON']>;
  dashboard?: InputMaybe<Scalars['JSON']>;
  features?: InputMaybe<Scalars['JSON']>;
  help_url?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Scalars['JSON']>;
  layouts?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  offers?: InputMaybe<Scalars['JSON']>;
  pages?: InputMaybe<Scalars['JSON']>;
  restrict_to_mls?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  support_email?: InputMaybe<Scalars['String']>;
  support_url?: InputMaybe<Scalars['String']>;
  tabs?: InputMaybe<Scalars['JSON']>;
}>;


export type UpdateAccountSettingMutation = { updateAccountSetting?: { accountSetting: { id: string } } | null };

export type DestroyAccountSettingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyAccountSettingMutation = { destroyAccountSetting?: { accountSetting: { id: string } } | null };

export type BrokerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BrokerQuery = { broker?: { mlsFeeds?: Array<string> | null, id: string, inviteCount?: number | null, key: string, logo?: string | null, name: string, officeAddress?: string | null, phone?: string | null, status: AccountStatusEnum, admin?: { avatar?: string | null, city?: string | null, email: string, id: string, mobilePhone?: string | null, name: string, state?: string | null, status: UserStatusEnum, mlsCredential?: { code?: string | null, name?: string | null, password?: string | null } | null } | null, agents: { total: number, edges?: Array<{ node?: { id: string, isBrokerAdmin: boolean, status: AccountStatusEnum, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null };

export type CancelBrokerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelBrokerMutation = { cancelBrokerAccount?: { errors?: Array<string> | null } | null };

export type BrokerAgentExistenceQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type BrokerAgentExistenceQuery = { user?: { id: string, isAdmin?: boolean | null } | null };

export type BrokerAgentPartsFragment = { id: string, firstname?: string | null, lastname?: string | null, email: string, isBrokerAdmin: boolean, status: AccountStatusEnum, avatar?: string | null, reportCount?: number | null, lastLoggedIn?: any | null, recentReport?: { __typename: 'CmaReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'DocumentReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'EmailReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'FlyerReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'HomebeatReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'LiveTour', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'PropertyReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'TourReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | null };

export type BrokerAgentsQueryVariables = Exact<{
  id: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<AgentFilterInput> | AgentFilterInput>;
  sortKey?: InputMaybe<AgentSortEnum>;
}>;


export type BrokerAgentsQuery = { broker?: { agents: { total: number, pageInfo: { startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ node?: { id: string, firstname?: string | null, lastname?: string | null, email: string, isBrokerAdmin: boolean, status: AccountStatusEnum, avatar?: string | null, reportCount?: number | null, lastLoggedIn?: any | null, recentReport?: { __typename: 'CmaReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'DocumentReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'EmailReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'FlyerReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'HomebeatReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'LiveTour', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'PropertyReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | { __typename: 'TourReport', title: string, updatedAt?: any | null, pdfPermalink?: string | null, guid?: string | null } | null } | null } | null> | null } } | null };

export type BrokerExistenceQueryVariables = Exact<{
  filters?: InputMaybe<Array<BrokerFilterInput> | BrokerFilterInput>;
}>;


export type BrokerExistenceQuery = { brokers: Array<{ id: string }> };

export type BrokerStatsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BrokerStatsQuery = { broker?: { stats: { monthlyActiveUsers?: Array<{ singleMonthStats?: Array<{ month: string, totalUsers: number, totalActiveUsers: number, cmaActiveUsers: number, flyerActiveUsers: number, buyerActiveUsers: number, propertyActiveUsers: number, homebeatActiveUsers: number, mls: { key?: string | null, title?: string | null } }> | null }> | null } } | null };

export type BrokersQueryVariables = Exact<{
  filters?: InputMaybe<Array<BrokerFilterInput> | BrokerFilterInput>;
}>;


export type BrokersQuery = { brokers: Array<{ id: string, name: string, key: string, seatsUsed?: number | null, activeAgentCount?: number | null, status: AccountStatusEnum, admin?: { name: string, email: string } | null }> };

export type GenerateBrokerAccountMutationVariables = Exact<{
  input: GenerateBrokerAccountInput;
}>;


export type GenerateBrokerAccountMutation = { generateBrokerAccount?: { errors?: Array<string> | null, account?: { id: string } | null } | null };

export type DestroyBrokerAgentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyBrokerAgentMutation = { destroyAgent?: { errors?: Array<string> | null, user?: { name: string } | null } | null };

export type ImportAgentsMutationVariables = Exact<{
  brokerId: Scalars['ID'];
  agents: Array<AgentUploadInput> | AgentUploadInput;
  sendInvitation?: InputMaybe<Scalars['Boolean']>;
}>;


export type ImportAgentsMutation = { importAgents?: { errors?: Array<string> | null, importingErrors?: Array<string> | null, users?: Array<{ id: string }> | null } | null };

export type InviteBrokerMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type InviteBrokerMutation = { inviteBroker?: { errors?: Array<string> | null } | null };

export type InviteBrokerAgentsMutationVariables = Exact<{
  accountId: Scalars['ID'];
  agentIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type InviteBrokerAgentsMutation = { sendAgentInvites?: { errors?: Array<string> | null } | null };

export type UpdateBrokerAccountMutationVariables = Exact<{
  input: UpdateBrokerAccountInput;
}>;


export type UpdateBrokerAccountMutation = { updateBrokerAccount?: { account?: { id: string, logo?: string | null, phone?: string | null, officeAddress?: string | null } | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  partnershipLogin?: InputMaybe<Scalars['Boolean']>;
}>;


export type LoginMutation = { authenticate?: { user?: { casJwt?: string | null, features?: { offerRdcToolkit?: boolean | null } | null } | null } | null };

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestResetPasswordMutation = { requestResetPassword?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  resetPasswordToken: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword?: { errors?: Array<string> | null, user?: { id: string } | null } | null };

export type CreateFlyerMutationVariables = Exact<{
  input: FlyerInput;
}>;


export type CreateFlyerMutation = { createFlyer?: { errors?: Array<string> | null, flyer?: { id: string } | null } | null };

export type DestroyFlyerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyFlyerMutation = { destroyFlyer?: boolean | null };

export type UpdateFlyerMutationVariables = Exact<{
  id: Scalars['ID'];
  input: FlyerInput;
}>;


export type UpdateFlyerMutation = { updateFlyer?: { errors?: Array<string> | null, flyer?: { id: string } | null } | null };

export type IntercomConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type IntercomConfigQuery = { currentUser?: { name: string, email: string, createdAt?: any | null, deleted?: boolean | null, userHash?: string | null, mlsCredential?: { code?: string | null, name?: string | null } | null, account?: { name?: string | null, isSiteLicensed?: boolean | null, type?: string | null } | null, features?: { hasIntercomChat?: boolean | null, hasLuxePowerPack?: boolean | null, hasLuxePowerPackUpgrade?: boolean | null, has2013MarketingPack?: boolean | null, hasTomFerryPack?: boolean | null } | null, stats?: { cmaCount?: number | null, buyerCount?: number | null, flyerCount?: number | null, propertyCount?: number | null } | null } | null };

export type ListingSearchPartsFragment = { acres?: number | null, address?: string | null, area?: string | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, bathsQuarter?: string | null, bathsThreeQuarter?: string | null, beds?: number | null, city?: string | null, county?: string | null, data?: any | null, dateList?: any | null, dateOffmarket?: any | null, dateSold?: any | null, dom?: number | null, features?: any | null, formattedBaths?: string | null, garages?: number | null, geoLat?: number | null, geoLon?: number | null, hide?: boolean | null, id: string, lat?: number | null, lon?: number | null, lotdim?: string | null, lotsize?: string | null, mappedStatus?: string | null, mlsnum?: string | null, photos?: Array<string> | null, position?: number | null, price?: number | null, priceList?: number | null, priceListOrig?: number | null, pricePerSqft?: number | null, priceRaw?: number | null, priceSold?: number | null, propType?: string | null, remarks?: string | null, remarksPrivate?: string | null, schoolElementary?: string | null, schoolMiddle?: string | null, schoolHigh?: string | null, source?: string | null, sqft?: number | null, state?: string | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, street?: string | null, style?: string | null, subdivision?: string | null, taxes?: string | null, updatedAt?: any | null, yearBuilt?: number | null, zip?: string | null, agentList?: { agentId?: string | null, email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, changes?: Array<{ timestamp?: any | null, changes?: Array<{ oldValue?: string | null, newValue?: string | null, field?: string | null }> | null }> | null, officeList?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, schools?: Array<{ name?: string | null, distance?: number | null, level?: string | null }> | null };

export type ListingSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type ListingSearchQuery = { listingsByAddressOrMlsNums?: { listings?: Array<{ acres?: number | null, address?: string | null, area?: string | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, bathsQuarter?: string | null, bathsThreeQuarter?: string | null, beds?: number | null, city?: string | null, county?: string | null, data?: any | null, dateList?: any | null, dateOffmarket?: any | null, dateSold?: any | null, dom?: number | null, features?: any | null, formattedBaths?: string | null, garages?: number | null, geoLat?: number | null, geoLon?: number | null, hide?: boolean | null, id: string, lat?: number | null, lon?: number | null, lotdim?: string | null, lotsize?: string | null, mappedStatus?: string | null, mlsnum?: string | null, photos?: Array<string> | null, position?: number | null, price?: number | null, priceList?: number | null, priceListOrig?: number | null, pricePerSqft?: number | null, priceRaw?: number | null, priceSold?: number | null, propType?: string | null, remarks?: string | null, remarksPrivate?: string | null, schoolElementary?: string | null, schoolMiddle?: string | null, schoolHigh?: string | null, source?: string | null, sqft?: number | null, state?: string | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, street?: string | null, style?: string | null, subdivision?: string | null, taxes?: string | null, updatedAt?: any | null, yearBuilt?: number | null, zip?: string | null, agentList?: { agentId?: string | null, email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, changes?: Array<{ timestamp?: any | null, changes?: Array<{ oldValue?: string | null, newValue?: string | null, field?: string | null }> | null }> | null, officeList?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, schools?: Array<{ name?: string | null, distance?: number | null, level?: string | null }> | null }> | null } | null };

export type CreateReportListingMutationVariables = Exact<{
  reportId: Scalars['ID'];
  listing: ListingInput;
}>;


export type CreateReportListingMutation = { createListing?: { listing?: { id: string } | null } | null };

export type DestroyReportListingMutationVariables = Exact<{
  listingId: Scalars['ID'];
}>;


export type DestroyReportListingMutation = { destroyListing?: { errors?: Array<string> | null, listing?: { id: string } | null } | null };

export type EmailReportMutationVariables = Exact<{
  id: Scalars['ID'];
  input: EmailReportInput;
}>;


export type EmailReportMutation = { emailReport?: { errors?: Array<string> | null } | null };

export type PublishReportMutationVariables = Exact<{
  id: Scalars['ID'];
  template?: InputMaybe<Scalars['String']>;
}>;


export type PublishReportMutation = { publishReport?: { errors?: Array<string> | null, report?: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null } | null };

export type ReorderReportListingsMutationVariables = Exact<{
  reportId: Scalars['ID'];
  listingIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderReportListingsMutation = { sortListings?: { errors?: Array<string> | null } | null };

export type ListingPartsFragment = { id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null };

type ReportParts_CmaReport_Fragment = { __typename: 'CmaReport', bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, sqftMin?: number | null, sqftMax?: number | null, lotsizeMin?: number | null, lotsizeMax?: number | null, priceListMin?: number | null, priceListMax?: number | null, proximitySearch?: boolean | null, minListings?: number | null, monthsBack?: number | null, id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_DocumentReport_Fragment = { __typename: 'DocumentReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_EmailReport_Fragment = { __typename: 'EmailReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_FlyerReport_Fragment = { __typename: 'FlyerReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, headline?: { key: string, value: string } | null, headlines?: Array<{ key: string, value: string }> | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_HomebeatReport_Fragment = { __typename: 'HomebeatReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_LiveTour_Fragment = { __typename: 'LiveTour', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_PropertyReport_Fragment = { __typename: 'PropertyReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

type ReportParts_TourReport_Fragment = { __typename: 'TourReport', listingCount?: number | null, cities?: Array<string> | null, id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null };

export type ReportPartsFragment = ReportParts_CmaReport_Fragment | ReportParts_DocumentReport_Fragment | ReportParts_EmailReport_Fragment | ReportParts_FlyerReport_Fragment | ReportParts_HomebeatReport_Fragment | ReportParts_LiveTour_Fragment | ReportParts_PropertyReport_Fragment | ReportParts_TourReport_Fragment;

export type ReportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportQuery = { report?: { __typename: 'CmaReport', bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, sqftMin?: number | null, sqftMax?: number | null, lotsizeMin?: number | null, lotsizeMax?: number | null, priceListMin?: number | null, priceListMax?: number | null, proximitySearch?: boolean | null, minListings?: number | null, monthsBack?: number | null, id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'DocumentReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'EmailReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'FlyerReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, headline?: { key: string, value: string } | null, headlines?: Array<{ key: string, value: string }> | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'HomebeatReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'LiveTour', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'PropertyReport', id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | { __typename: 'TourReport', listingCount?: number | null, cities?: Array<string> | null, id: string, title: string, notes?: string | null, address?: string | null, pdfPermalink?: string | null, status?: string | null, guid?: string | null, isModern?: boolean | null, description: string, addressParts?: Array<string> | null, thumbnail?: string | null, theme: { key: string, value: string }, themes: Array<{ key: string, value: string, preview?: Array<string> | null, type: ThemeTypeEnum, color: { primary?: string | null, secondary: string } }>, font: { key: string, value: string }, fonts?: Array<{ key: string, url?: string | null, value: string }> | null, layout: { key: string, value: string }, layouts: Array<{ key: string, value: string, preview?: string | null, type: ReportThemeTypeEnum }>, listings?: Array<{ id: string, address?: string | null, city?: string | null, state?: string | null, zip?: string | null, price?: number | null, priceListOrig?: number | null, priceList?: number | null, priceSold?: number | null, pricePerSqft?: number | null, hide?: boolean | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, photos?: Array<string> | null, beds?: number | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, formattedBaths?: string | null, sqft?: number | null, yearBuilt?: number | null, propType?: string | null, dateList?: any | null, dateSold?: any | null, dom?: number | null, position?: number | null, remarks?: string | null, lotsize?: string | null, lotdim?: string | null, taxes?: string | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null, source?: string | null, updatedAt?: any | null, county?: string | null, mlsnum?: string | null, features?: any | null, dateOffmarket?: any | null, lat?: number | null, lon?: number | null }> | null, subjectProperty?: { address?: string | null, lat?: number | null, lon?: number | null, beds?: number | null, baths?: number | null, sqft?: number | null, propType?: string | null, propSubType?: string | null, photo?: string | null, lotSize?: string | null, landMeasurement?: string | null, yearBuilt?: number | null, taxes?: number | null, garages?: number | null, area?: string | null, subdivision?: string | null, style?: string | null } | null } | null };

export type ReportStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportStatusQuery = { report?: { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | { id: string, status?: string | null } | null };

export type ReportTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReportTemplatesQuery = { reportTemplates?: { pageTemplates?: Array<{ id?: string | null, title?: string | null, pageCount?: number | null, isCustom?: boolean | null }> | null } | null };

export type ReportsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<ReportTypeEnum> | ReportTypeEnum>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortInput>;
}>;


export type ReportsQuery = { reports?: { total: number, pageInfo: { hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename: 'CmaReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'DocumentReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'EmailReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'FlyerReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'HomebeatReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'LiveTour', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'PropertyReport', id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | { __typename: 'TourReport', listingCount?: number | null, cities?: Array<string> | null, id: string, address?: string | null, title: string, pdfPermalink?: string | null, status?: string | null, guid?: string | null, notes?: string | null, viewCount?: number | null, lastViewedAt?: any | null, updatedAt?: any | null, addressParts?: Array<string> | null, thumbnail?: string | null, subjectProperty?: { beds?: number | null, baths?: number | null, sqft?: number | null, garages?: number | null, lotSize?: string | null, propType?: string | null, propSubType?: string | null } | null } | null> | null } | null };

export type SortReportListingsMutationVariables = Exact<{
  reportId: Scalars['ID'];
  sortBy: Scalars['String'];
  sortDir: SortDirectionEnum;
}>;


export type SortReportListingsMutation = { sortByListing?: { errors?: Array<string> | null } | null };

export type ToggleReportListingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ToggleReportListingMutation = { toggleListingVisibility?: { errors?: Array<string> | null } | null };

export type ToggleReportListingsMutationVariables = Exact<{
  reportId: Scalars['ID'];
  visible: Scalars['Boolean'];
}>;


export type ToggleReportListingsMutation = { updateReportListingsVisibility?: { errors?: Array<string> | null } | null };

export type UpdateReportListingMutationVariables = Exact<{
  listingId: Scalars['ID'];
  listing: ListingInput;
}>;


export type UpdateReportListingMutation = { updateListing?: { listing?: { id: string } | null } | null };

export type AddContactItemMutationVariables = Exact<{
  input: ContactItemInput;
}>;


export type AddContactItemMutation = { createContactItem?: { errors?: Array<string> | null, contactItem?: { id: string } | null } | null };

export type AddIntegrationMutationVariables = Exact<{
  key: IntegrationTypeEnum;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
}>;


export type AddIntegrationMutation = { updateIntegrationCredential?: { errors?: Array<string> | null, apiCredential?: { key?: string | null, name?: string | null } | null } | null };

export type AddOrChangeAlternateMlsMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  code: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type AddOrChangeAlternateMlsMutation = { AddOrChangeAlternateMlsCredential?: { errors?: Array<string> | null, alternateMlsCredential?: { id: string, code?: string | null, name?: string | null } | null } | null };

export type AddZipFormMutationVariables = Exact<{
  username?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
}>;


export type AddZipFormMutation = { connectZipForm?: { contextId?: string | null, errors?: Array<string> | null } | null };

export type AlternateMlsPartsFragment = { id: string, code?: string | null, name?: string | null, password?: string | null };

export type AlternateMlsesQueryVariables = Exact<{ [key: string]: never; }>;


export type AlternateMlsesQuery = { alternateMlses?: { mlses?: Array<{ id: string, code?: string | null, name?: string | null, password?: string | null }> | null } | null };

export type BillingAccountPartsFragment = { isSiteLicensed?: boolean | null, isSmallBroker?: boolean | null, isShared?: boolean | null, admin?: { companyName?: string | null } | null, subscription?: { amount?: number | null, cardExpiration?: string | null, cardNumber?: string | null, id: string, isFree?: boolean | null, isPurchasedFromOutsideStore?: boolean | null, nextRenewalAt?: any | null, state?: string | null, affiliate?: { name?: string | null, token?: string | null } | null, discount?: { amount: number, code: string, id: string } | null, subscriptionPlan?: { description?: string | null, id: string, label?: string | null, name?: string | null } | null } | null };

export type BillingOrderPartsFragment = { billingUrl?: string | null, chargeDate?: any | null, id: string, isPaid?: boolean | null, isRecurring?: boolean | null, name?: string | null, price?: number | null };

export type BillingQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingQuery = { currentUser?: { id: string, isAccountAdmin?: boolean | null, isCasUser?: boolean | null, hasCardOnFile?: boolean | null, name: string, email: string, companyName?: string | null, lwaId?: string | null, eligiblePlans?: Array<{ description?: string | null, id: string, label?: string | null, name?: string | null }> | null, orders?: Array<{ billingUrl?: string | null, chargeDate?: any | null, id: string, isPaid?: boolean | null, isRecurring?: boolean | null, name?: string | null, price?: number | null }> | null, account?: { isSiteLicensed?: boolean | null, isSmallBroker?: boolean | null, isShared?: boolean | null, admin?: { companyName?: string | null } | null, subscription?: { amount?: number | null, cardExpiration?: string | null, cardNumber?: string | null, id: string, isFree?: boolean | null, isPurchasedFromOutsideStore?: boolean | null, nextRenewalAt?: any | null, state?: string | null, affiliate?: { name?: string | null, token?: string | null } | null, discount?: { amount: number, code: string, id: string } | null, subscriptionPlan?: { description?: string | null, id: string, label?: string | null, name?: string | null } | null } | null } | null } | null };

export type BoostQueryVariables = Exact<{ [key: string]: never; }>;


export type BoostQuery = { boostRedirectLink: { url?: string | null } };

export type ContactItemPartsFragment = { id: string, position?: number | null, prettyKey?: string | null, value?: string | null };

export type ContactItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactItemsQuery = { currentUser?: { contactItems?: Array<{ id: string, position?: number | null, prettyKey?: string | null, value?: string | null }> | null } | null };

export type ContactMethodPartsFragment = { key: string, prettyKey?: string | null };

export type ContactMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactMethodsQuery = { currentUser?: { contactMethods?: Array<{ key: string, prettyKey?: string | null }> | null } | null };

export type CreateCustomPageMutationVariables = Exact<{
  input: CustomPageInput;
}>;


export type CreateCustomPageMutation = { createCustomPage?: { errors?: Array<string> | null, customPage?: { key?: string | null } | null } | null };

export type CreateCustomPdfMutationVariables = Exact<{
  input: CustomPdfInput;
}>;


export type CreateCustomPdfMutation = { createCustomPdf?: { errors?: Array<string> | null, customPdf?: { id?: string | null } | null } | null };

export type CustomPagePartsFragment = { canModify?: boolean | null, content?: string | null, id?: string | null, isDefault?: boolean | null, key?: string | null, title?: string | null };

export type CustomPagesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomPagesQuery = { currentUser?: { customPages?: Array<{ canModify?: boolean | null, content?: string | null, id?: string | null, isDefault?: boolean | null, key?: string | null, title?: string | null }> | null } | null };

export type CustomPdfPartsFragment = { id?: string | null, title?: string | null, url?: string | null, image?: string | null };

export type CustomPdfsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomPdfsQuery = { currentUser?: { customPdfs?: Array<{ id?: string | null, title?: string | null, url?: string | null, image?: string | null }> | null } | null };

export type DestroyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DestroyAccountMutation = { cancelAccount?: boolean | null };

export type DestroyAlternateMlsCredentialMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyAlternateMlsCredentialMutation = { destroyAlternateMlsCredential?: boolean | null };

export type DestroyContactItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyContactItemMutation = { destroyContactItem?: { errors?: Array<string> | null, contactItem?: { id: string } | null } | null };

export type DestroyCustomPageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyCustomPageMutation = { destroyCustomPage?: { errors?: Array<string> | null, customPage?: { id?: string | null } | null } | null };

export type DestroyCustomPdfMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyCustomPdfMutation = { destroyCustomPdf?: { errors?: Array<string> | null, customPdf?: { id?: string | null } | null } | null };

export type DestroyOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyOrderMutation = { destroyOrder?: { errors?: Array<string> | null, result?: boolean | null } | null };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { currentUser?: { integrations?: Array<{ key?: string | null, name?: string | null, password?: string | null }> | null } | null };

export type MlsPartsFragment = { title?: string | null, key?: string | null, states?: Array<string> | null, instructions?: string | null };

export type MlsesQueryVariables = Exact<{
  restrict?: InputMaybe<Scalars['Boolean']>;
}>;


export type MlsesQuery = { mlses: Array<{ title?: string | null, key?: string | null, states?: Array<string> | null, instructions?: string | null }> };

export type ReceiptsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReceiptsQuery = { currentUser?: { receipts?: Array<{ amount?: number | null, createdAt: any, product: string, type?: string | null } | { amount?: number | null, createdAt: any, product: string, type?: string | null }> | null } | null };

export type RemoveIntegrationMutationVariables = Exact<{
  key: IntegrationTypeEnum;
}>;


export type RemoveIntegrationMutation = { disconnectIntegration?: { result?: boolean | null, errors?: Array<string> | null } | null };

export type SortContactItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SortContactItemsMutation = { sortContactItems?: { errors?: Array<string> | null, contactItems?: Array<{ id: string }> | null } | null };

export type UpdateCustomPageMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CustomPageInput;
}>;


export type UpdateCustomPageMutation = { updateCustomPage?: { errors?: Array<string> | null, customPage?: { key?: string | null } | null } | null };

export type UpdateMlsCredentialMutationVariables = Exact<{
  input: MlsCredentialInput;
}>;


export type UpdateMlsCredentialMutation = { updateMlsCredential?: { errors?: Array<string> | null, mlsCredential?: { code?: string | null } | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type UpdatePasswordMutation = { updateUserPassword?: { errors?: Array<string> | null, user?: { id: string } | null } | null };

export type UpdatePlanMutationVariables = Exact<{
  planId?: InputMaybe<Scalars['ID']>;
  discountCode?: InputMaybe<Scalars['String']>;
  nonce?: InputMaybe<Scalars['String']>;
}>;


export type UpdatePlanMutation = { updateSubscriptionPlan?: { errors?: Array<string> | null, result?: boolean | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UserProfileInput;
}>;


export type UpdateUserProfileMutation = { updateUserProfile?: { errors?: Array<string> | null, user?: { avatar?: string | null, companyLogoUrl?: string | null, status: UserStatusEnum } | null } | null };

export type SendMagicLinkMutationVariables = Exact<{
  email: Scalars['String'];
  token: Scalars['String'];
}>;


export type SendMagicLinkMutation = { createMagicLink?: { errors?: Array<string> | null, result?: boolean | null } | null };

export type PotentialUsersPartsFragment = { id: string, name: string, email: string, belongsToBroker?: boolean | null, companyName?: string | null, lastSignInAt?: any | null, account?: { key?: string | null, name?: string | null } | null, mlsCredential?: { id: string, code?: string | null, mlsName?: string | null, name?: string | null } | null, stats?: { buyerCount?: number | null, cmaCount?: number | null, flyerCount?: number | null, propertyCount?: number | null } | null };

export type PotentialUsersQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PotentialUsersQuery = { potentialUsers?: Array<{ id: string, name: string, email: string, belongsToBroker?: boolean | null, companyName?: string | null, lastSignInAt?: any | null, account?: { key?: string | null, name?: string | null } | null, mlsCredential?: { id: string, code?: string | null, mlsName?: string | null, name?: string | null } | null, stats?: { buyerCount?: number | null, cmaCount?: number | null, flyerCount?: number | null, propertyCount?: number | null } | null }> | null };

export type PartnershipUserSignupMutationVariables = Exact<{
  token: Scalars['String'];
  input: UserInput;
  ouid: Scalars['String'];
}>;


export type PartnershipUserSignupMutation = { partnershipUserSignup?: { redirectUrl?: string | null, errors?: Array<string> | null, user?: { casJwt?: string | null } | null } | null };

export type PartnershipUserConnectMutationVariables = Exact<{
  token: Scalars['String'];
  ouid: Scalars['String'];
}>;


export type PartnershipUserConnectMutation = { partnershipUserConnect?: { redirectUrl?: string | null, errors?: Array<string> | null } | null };

export type PartnershipUserQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PartnershipUserQuery = { partnershipUser?: { companyName?: string | null, email?: string | null, firstName?: string | null, id: string, lastName?: string | null, mlsId?: string | null, ouid?: string | null, partnershipId?: number | null, phoneNumber?: string | null, mls?: { title?: string | null } | null, mlsOptions?: Array<{ mlsId?: string | null, mlsKey?: string | null, mlsName?: string | null, ouid?: string | null }> | null } | null };

export type CreateTourMutationVariables = Exact<{
  input: LiveTourInput;
}>;


export type CreateTourMutation = { createTour?: { tour?: { id: string } | null } | null };

export type TourQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TourQuery = { tour?: { id: string, title: string, tourDate?: any | null, status?: string | null, pdfPermalink?: string | null, pageTemplate?: string | null, agent?: { id: string, avatar?: string | null, name: string, officePhone?: string | null, mobilePhone?: string | null, companyLogoUrl?: string | null } | null, appointments: Array<{ endTime?: any | null, id: string, note?: string | null, position?: number | null, startTime?: any | null, listing: { acres?: number | null, address?: string | null, area?: string | null, baths?: string | null, bathsFull?: string | null, bathsHalf?: string | null, bathsQuarter?: string | null, bathsThreeQuarter?: string | null, beds?: number | null, city?: string | null, comment?: string | null, county?: string | null, data?: any | null, dateList?: any | null, dateOffmarket?: any | null, dateSold?: any | null, dom?: number | null, features?: any | null, formattedBaths?: string | null, garages?: number | null, geoLat?: number | null, geoLon?: number | null, hide?: boolean | null, id: string, lat?: number | null, lon?: number | null, lotdim?: string | null, lotsize?: string | null, mappedStatus?: string | null, mlsnum?: string | null, photos?: Array<string> | null, position?: number | null, price?: number | null, priceList?: number | null, priceListOrig?: number | null, pricePerSqft?: number | null, priceRaw?: number | null, priceSold?: number | null, propType?: string | null, rating?: number | null, remarks?: string | null, remarksPrivate?: string | null, schoolElementary?: string | null, schoolHigh?: string | null, schoolMiddle?: string | null, source?: string | null, sqft?: number | null, state?: string | null, status?: string | null, statusAsColor?: string | null, statusAsLetter?: string | null, street?: string | null, style?: string | null, subdivision?: string | null, taxes?: string | null, updatedAt?: any | null, yearBuilt?: number | null, zip?: string | null, changes?: Array<{ timestamp?: any | null, changes?: Array<{ oldValue?: string | null, newValue?: string | null, field?: string | null }> | null }> | null, agentList?: { agentId?: string | null, email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, officeList?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, schools?: Array<{ name?: string | null, distance?: number | null, level?: string | null }> | null } }> } | null };

export type UpdateTourMutationVariables = Exact<{
  id: Scalars['ID'];
  input: LiveTourInput;
}>;


export type UpdateTourMutation = { updateTour?: { errors?: Array<string> | null, tour?: { id: string } | null } | null };

export type UpdateTourListingMutationVariables = Exact<{
  id: Scalars['ID'];
  input: PublicListingInput;
}>;


export type UpdateTourListingMutation = { updatePublicListing?: { errors?: Array<string> | null } | null };

export type TranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type TranslationsQuery = { translations: { mls: { label: string }, listing: { county: string } } };

export type EmailHomeWorthMutationVariables = Exact<{
  input: CmaWidgetInput;
}>;


export type EmailHomeWorthMutation = { cmaWidget?: { errors?: Array<string> | null } | null };

export type HomeWorthQueryVariables = Exact<{
  guid?: InputMaybe<Scalars['String']>;
}>;


export type HomeWorthQuery = { user?: { id: string, name: string, email: string, avatar?: string | null, companyName?: string | null, officePhone?: string | null, mobilePhone?: string | null, licenseNumber?: string | null, licenseLabel?: string | null, website?: string | null } | null };
